import api from '@/core/apiclient'
import { actionTypes } from '@/core/constants'

export default {
	async [actionTypes.TIPO.BUSCAR_TIPOS_POR_PROCESSO]({ state }, filtro) {
		const { paginacao } = state
		const { data } = await api.tipo.buscaTiposPorProcesso(filtro, paginacao)
		return data
	},

	async [actionTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.BUSCAR_TIPOS_POR_NUMERO_E_PROCESSO]({ state }) {
		const { filtro, paginacao } = state.porNumeroEItemProcesso
		const { data } = await api.tipo.buscaTiposPorNumeroEProcesso(filtro, paginacao)
		return data
	},
}
